import http from '../../axios';
import {AnswerRes, MeetState, Replica} from "@/store/meet/types";
import PlayerStore from "@/store/player";
import {GameState} from "@/constants/game-state";
import {HintState} from "@/store/player/types";
import ListenerManager from "@/managers/listener-manager";

export default class MeetStore {

    private static state: MeetState = {
        replica: undefined
    }

    public static SET_REPLICA(replica: Replica) {
        MeetStore.state.replica = replica;
    }

    public static getReplica() {
        return MeetStore.state.replica;
    }

    public static fetchReplica(placeId: number): Promise<Replica> {
        return http.post('/api/customPlace/v2/' + String(placeId) + '/ensure')
            .then(r => r.data)
            .then(replicaObj => {
                let replica = Object.assign(new Replica(), replicaObj);
                MeetStore.SET_REPLICA(replica);
                return replica;
            });
    }

    public static answer(placeId: number, replicaId: string, answerId: string, handleResult: boolean): Promise<any> {
        var params = new URLSearchParams();
        params.append('placeId', String(placeId));
        params.append('replicaId', replicaId);
        params.append('answerId', answerId);

        if (handleResult) {
            return http.post('/api/customPlace/v4/answer', params)
                .then(r => r.data)
                .then(replicaObj => {
                    let replica = Object.assign(new Replica(), replicaObj);
                    MeetStore.SET_REPLICA(replica);
                    if (replica.player) {
                        if (replica.refreshNavPanel) {
                            GameState.REQUEST_REFRESH_NAV_PANEL = true;
                        }
                        PlayerStore.SET_PLAYER_SKIP_CR(replica.player);
                    }
                    return replica;
                });
        } else {
            return http.post('/api/customPlace/v4/shortened/answer', params)
                .then(r => r.data)
                .then(obj => {
                    let answerRes = Object.assign(new AnswerRes(), obj);
                    if (answerRes.hintState === HintState.UNSEEN) {
                        PlayerStore.getPlayer().hintState = answerRes.hintState;
                        ListenerManager.callUpdateHintCallback();
                    }
                });
        }
    }
}
